jQuery(function($) {
  let $modal, $video_container, $close_modal, $focus_trap, $tab_bookmark;

  $modal = $('#js-modal');
  $video_container = $('#js-add-video');
  $close_modal = $('#js-close-modal');
  $focus_trap = $('#js-trap-focus');

  // Open Modal and inject iframe
  $('.js-video-modal').click(function() {
    let $video_id, $iframe;
    $tab_bookmark = $(this);
    $video_id = $(this).data('source');
    $iframe = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + $video_id + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

    $modal.show();

    $video_container.append($iframe);
    $close_modal.focus();
  });

  function closeModal() {
    $modal.hide();
    $video_container.empty();
    if ($tab_bookmark !== undefined) {
      $tab_bookmark.focus();
    }
  }

  // Close modal listener for close button
  $close_modal.click(function() {
    closeModal();
  });

  // When the user clicks anywhere outside of the modal, close it
  $(window).click(function(event) {
    if (event.target.id === 'js-modal') {
      closeModal();
    }
  });

  $(document).keydown(function(event) {
    if (event.keyCode === 27) {
      closeModal();
    }
  });

  // add all the elements inside modal which you want to make focusable
  $focus_trap.on('focus', function(e) {
    $close_modal.focus(); // add focus for the first focusable element
    e.preventDefault();
  });

  $close_modal.on('keydown', function(e) {
    if (e.shiftKey) {
      e.preventDefault();
    }
  });

  // Pause homescreen video
  let hero_video = document.getElementById('homepage-video');
  const motion = localStorage.getItem('motion');
  if (motion === 'stopped') {
    $('body').addClass('frozen');
    $('#reduce').prop('checked', true);
    if ($(window).width() > 1024 && hero_video) {
      hero_video.pause();
    }
  }
  else {
    $('body').removeClass('frozen');
    $('#resume').prop('checked', true);
    if ($(window).width() > 1024 && hero_video) {
      hero_video.play();
    }
  }

  $('.video-toggle input').change(function() {
    if (this.value === 'stopped') {
      $('body').addClass('frozen');
      if ($(window).width() > 1024 && hero_video) {
        hero_video.pause();
      }
    }
    else {
      $('body').removeClass('frozen');
      if ($(window).width() > 1024 && hero_video) {
        hero_video.play();
      }
    }
    localStorage.setItem('motion', this.value);
  });

  $('.gatedvideo').click(function(e) {
    console.log($(this).data('source'));
    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'json',
      data: {
        action: 'videolog',
        videoid: $(this).data('source')
      },
      success: function(res) {
        console.log(res);
      },
      error: function(err) {
        console.error(err);
      }
    });
  });
});
